export default "__VITE_ASSET__BxgW2Y2d__"